<template>
    <div>
        <b-card>
          <validation-observer ref="form" slim>
            <div class="row">
              <div class="col-lg-4">
                <validation-provider
                  name="training name"
                  rules="required|max:150"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="Training Name *"
                    :invalid-feedback="errors[0]"
                  >
                    <b-form-input
                      placeholder="Enter training name"
                      v-model="form.name"
                      trim
                      :class="{ 'is-invalid': errors.length }"
                    />
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="training type"
                  rules="required|max:9"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="Training Type *"
                    :invalid-feedback="errors[0]"
                  >
                    <custom-select
                      v-model="form.trainingType"
                      label="text"
                      :options="trainingTypes"
                      :clearable="false"
                      placeholder="Select training type"
                      :class="{ 'is-invalid': errors.length }"
                    />
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="provider"
                  rules="required|max:50"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="Provider *"
                    :invalid-feedback="errors[0]"
                  >
                   <custom-select
                        v-model="form.provider"
                        label="name"
                        multiple
                        :options="providerName"
                        :clearable="false"
                        placeholder="Select provider name"
                        :class="{ 'is-invalid': errors.length }"
                      />
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Start Date"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="Start Date *"
                    :invalid-feedback="errors[0]"
                  >
                    <date-picker
                      placeholder="Select start date"
                      type="date"
                      valueType="YYYY-MM-DD"
                      :value="formatDate(form.startDate)"
                      format="DD-MM-YYYY"
                      :editable="false"
                      :clearable="false"
                      v-model="form.startDate"
                      :class="{ 'is-invalid': errors.length }">
                    </date-picker>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-lg-4">
                  <validation-provider
                    name="End Date"
                    rules="required"
                    type="date"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="End Date *"
                      :invalid-feedback="errors[0]"
                    >
                      <date-picker
                        placeholder="Select end date"
                        type="date"
                        valueType="YYYY-MM-DD"
                        :value="formatDate(form.endDate)"
                        format="DD-MM-YYYY"
                        :editable="false"
                        :clearable="false"
                        v-model="form.endDate"
                        :class="{ 'is-invalid': errors.length }">
                      </date-picker>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    name="certificate number"
                    rules="required|max:50"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="Certificate Number *"
                      :invalid-feedback="errors[0]"
                    >
                      <b-form-input
                        placeholder="Enter certificate number"
                        v-model="form.certificateNumber"
                        trim
                        :class="{ 'is-invalid': errors.length }"
                      />
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    name="Certificate Expired"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="Certificate Expired"
                      type="date"
                      :invalid-feedback="errors[0]"
                    >
                      <date-picker
                        placeholder="Select certificated expired date"
                        type="date"
                        valueType="YYYY-MM-DD"
                        :value="form.certificateExpired"
                        format="DD-MM-YYYY"
                        :editable="false"
                        :clearable="false"
                        disabled
                        v-model="form.certificateExpired"
                        :class="{ 'is-invalid': errors.length }">
                      </date-picker>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    name="training context"
                    rules="required|max:50"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="Training Context *"
                      :invalid-feedback="errors[0]"
                    >
                      <custom-select
                        v-model="form.trainingContext"
                        label="name"
                        multiple
                        :options="trainingContext"
                        :clearable="false"
                        placeholder="Select training context"
                        :class="{ 'is-invalid': errors.length }"
                      />
                    </b-form-group>
                  </validation-provider>
              </div>
              <div class="col-lg-4">
                <validation-provider
                  name="framework"
                  rules="max:25"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="Framework"
                    :invalid-feedback="errors[0]"
                  >
                    <custom-select
                      v-model="form.framework"
                      label="name"
                      multiple
                      :options="framework"
                      :clearable="false"
                      placeholder="Select framework"
                      :class="{ 'is-invalid': errors.length }"
                    />
                  </b-form-group>
                </validation-provider>
                <validation-provider
                    name="operating system"
                    rules="max:25"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="Operating System"
                      :invalid-feedback="errors[0]"
                    >
                      <custom-select
                        v-model="form.operatingSystem"
                        label="name"
                        multiple
                        :options="operatingSystem"
                        :clearable="false"
                        placeholder="Select operating system"
                        :class="{ 'is-invalid': errors.length }"
                      />
                  </b-form-group>
                </validation-provider>
                <validation-provider
                    name="platform"
                    rules="required|max:25"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="Platform *"
                      :invalid-feedback="errors[0]"
                    >
                      <custom-select
                        v-model="form.platform"
                        label="name"
                        multiple
                        :options="platform"
                        :clearable="false"
                        placeholder="Select platform"
                        :class="{ 'is-invalid': errors.length }"
                      />
                    </b-form-group>
                  </validation-provider>
              </div>
            </div>
          </validation-observer>
          <div class="d-flex justify-content-end">
              <b-button
              class="next merge d-flex justify-content-end ml-90"
              style="mr-90rem;"
              type="submit"
              variant="primary"
              @click="saveChange">
              Save Change
              </b-button>
          </div>
        </b-card>
    </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  props: {
    training: {
      type: Object,
      default: () => ({})
    }
  },
  components: { DatePicker },
  data() {
    return {
      employeeId: JSON.parse(localStorage.getItem('me')).employeeId,
      form: {
        employeeId: '',
        id: '',
        name: '',
        startDate: '',
        endDate: '',
        certificateNumber: '',
        certificateExpired: '',
        trainingType: '',
        provider: [],
        trainingContext: [],
        operatingSystem: [],
        platform: [],
        framework: []
      },
      show: true,
      trainingTypes: ['Eksternal', 'Internal'],
      providerName: [],
      trainingContext: [],
      framework: [],
      operatingSystem: [],
      platform: []
    }
  },
  created() {
    this.formatYear()
    this.fetchFramework()
    this.fetchPlatform()
    this.fetchOperatingSystem()
    this.fetchProvider()
    this.fetchTrainingContext()
    this.fetchEmployeeProfile()
  },
  mounted() {
    this.fetchGetTrainingEdit()
  },
  methods: {
    formatDate(date) {
      var value = date === '' ? 'DD-MM-YYYY' : moment(date).format('YYYY-MM-DD')
      return value
    },
    formatYear() {
      this.form.certificateExpired = moment().add(1, 'd').format('YYYY-MM-DD')
      this.form.startDate = moment().subtract(5, 'years').format('YYYY-MM-DD')
      this.form.endDate = moment().subtract(5, 'years').format('YYYY-MM-DD')
    },
    async fetchFramework() {
      const { data } = await api.knowledge.framework()
      this.framework = data
    },
    async fetchPlatform() {
      const { data } = await api.knowledge.platform()
      this.platform = data
    },
    async fetchOperatingSystem() {
      const { data } = await api.knowledge.operatingSystem()
      this.operatingSystem = data
    },
    async fetchProvider() {
      const { data } = await api.training.providerName()
      this.providerName = data
    },
    async fetchTrainingContext() {
      const { data } = await api.training.trainingContext()
      this.trainingContext = data
    },
    async fetchGetTrainingEdit() {
      const { data } = await api.training.getById(this.$route.params.id)
      this.form = data.data
    },
    async fetchEmployeeProfile() {
      const user = await api.employee.getById(this.employeeId)
      this.employee = user.data.data
    },
    async saveChange() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) {
          this.isBusy = false
          this.$nextTick(() => {
            this.$bvToast.toast('Cannot save changes', {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            })
          })
          return
        }
        const tempProviderName = []
        for (let i = 0; i < this.form.provider.length; i++) {
          tempProviderName.push({
            id: this.form.provider[i].id,
            name: this.form.provider[i].name
          })
        }
        const tempPlatform = []
        for (let i = 0; i < this.form.platform.length; i++) {
          tempPlatform.push({
            id: this.form.platform[i].id,
            name: this.form.platform[i].name
          })
        }
        const tempFramework = []
        for (let i = 0; i < this.form.framework.length; i++) {
          tempFramework.push({
            id: this.form.framework[i].id,
            name: this.form.framework[i].name
          })
        }
        const tempOperatingSystem = []
        for (let i = 0; i < this.form.operatingSystem.length; i++) {
          tempOperatingSystem.push({
            id: this.form.operatingSystem[i].id,
            name: this.form.operatingSystem[i].name
          })
        }
        const tempTrainingContext = []
        for (let i = 0; i < this.form.trainingContext.length; i++) {
          tempTrainingContext.push({
            id: this.form.trainingContext[i].id,
            name: this.form.trainingContext[i].name
          })
        }
        this.form.startDate = new Date(this.form.startDate)
        this.form.startDate = moment(this.form.startDate).add(7, 'h').format('YYYY-MM-DD HH:mm:ss')
        this.form.endDate = new Date(this.form.endDate)
        this.form.endDate = moment(this.form.endDate).add(7, 'h').format('YYYY-MM-DD HH:mm:ss')
        this.form.certificateExpired = new Date(this.form.certificateExpired)
        this.form.certificateExpired = moment(this.form.certificateExpired).add(7, 'h').format('YYYY-MM-DD HH:mm:ss')
        const formSend = {
          employeeId: this.employee.id,
          id: this.form.id,
          name: this.form.name,
          startDate: new Date(this.form.startDate),
          endDate: new Date(this.form.endDate),
          certificateNumber: this.form.certificateNumber,
          certificateExpired: new Date(this.form.certificateExpired),
          trainingType: this.form.trainingType,
          provider: tempProviderName,
          trainingContext: tempTrainingContext,
          operatingSystem: tempOperatingSystem,
          platform: tempPlatform,
          framework: tempFramework
        }
        await api.training.put(formSend.id, formSend)
        this.$nextTick(() => {
          setTimeout(() => {
            this.$bvToast.toast('Success save changes', {
              headerClass: 'd-none',
              solid: true,
              variant: 'success'
            })
          }, 500)
          localStorage.setItem('activeTab', 'Training')
          this.$router.push('/view-profile')
        })
      } catch (error) {
        this.isBusy = false
        this.$nextTick(() => {
          this.$bvToast.toast(error.message ? error.message.messageEng : error.data.messageEng, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    }
  }
}
</script>
